module.exports = __webpack_public_path__ + "img/cert33.40bee70b.jpg";